const ACTION_PREPEND = '@@ui';

export const SCREEN_RESIZE = `${ACTION_PREPEND}/SCREEN_RESIZE`;
export const SCREEN_ORIENTATION = `${ACTION_PREPEND}/SCREEN_ORIENTATION`;
export const BROWSER_TYPE = `${ACTION_PREPEND}/BROWSER_TYPE`;
export const SHOW_MOBILE_SIDEBAR = `${ACTION_PREPEND}/SHOW_MOBILE_SIDEBAR`;
export const TOGGLE_SUMMARY = `${ACTION_PREPEND}/TOGGLE_SUMMARY`;
export const CLOSE_SUMMARY = `${ACTION_PREPEND}/CLOSE_SUMMARY`;
export const MOBILE_ROUTE_TO_DASHBOARD = `${ACTION_PREPEND}/MOBILE_ROUTE_TO_DASHBOARD`;

export const screenResize = payload => ({
  type: SCREEN_RESIZE,
  payload
});

export const screenOrientation = payload => ({
  type: SCREEN_ORIENTATION,
  payload
});

export const browserType = payload => ({
  type: BROWSER_TYPE,
  payload
});

// This doesn't appear to be used but verify with mobile
export const toggleMobileSidebar = () => ({
  type: SHOW_MOBILE_SIDEBAR
});

export const toggleSummary = () => ({
  type: TOGGLE_SUMMARY
});

export const closeSummary = () => ({
  type: CLOSE_SUMMARY
});

export const toggleMobileRouteToDashboard = payload => ({
  type: MOBILE_ROUTE_TO_DASHBOARD,
  payload
});
